module.exports = __webpack_public_path__ + "img/DerVogelIstImmerDabei.5ed2ff63.svg";